/** UI copy for the app shell (sidebar, theme switch, year picker). Shared labels live in `COMMON_TEXT`. */
export const SHELL_TEXT = {
  sidebar: {
    mainNavigation: 'Main navigation',
    hideSidebar: 'Hide sidebar',
    myDesk: 'My Desk',
    unread: (count: number) => `${count} unread`,
    signOut: 'Sign out',
  },
  bell: {
    notifications: 'Notifications',
    unread: (count: number) => `Notifications (${count} unread)`,
  },
  theme: {
    label: 'Theme',
    light: 'Light',
    dark: 'Dark',
    auto: 'Auto',
  },
  yearPicker: {
    calendarYear: 'Calendar year',
    changeInSettings: 'Change the calendar year in My Profile',
    inUse: 'Calendar year in use',
    lastUsed: 'Last used',
    opened: (year: number) => `${year} opened · no work in it yet.`,
    openYearTitle: (year: number) => `Open calendar year ${year}`,
    openYear: (year: number) => `Open ${year}`,
    openYearMessage: (year: number) =>
      `${year} will be available in the year switch with no work in it yet. Use Rollover in Client Master to carry clients forward into it.`,
  },
} as const;
